import { get } from "@/core/request";
import { getCommonHeader } from "./config";


// 获取用户信息
// todo test
export const fetchUserInfo = async (parm) => {
    const { spaceId, userId } = parm;
    return get({
        url: `/uic/web/member/detail?spaceId=${spaceId}&userId=${userId}`,
        baseURL: "",
        headers: getCommonHeader()
    });
};
